import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Children, useMemo } from 'react';
import { getValidChild } from '@helpers';
import { StyledModalContainer } from './modal.styles';
import { ModalButtons } from './slots/modal-buttons';
import { ModalContent } from './slots/modal-content';
import { ModalFooter } from './slots/modal-footer';
import { ModalTitle } from './slots/modal-title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Modal = function Modal(_ref) {
  var children = _ref.children;
  var childrenArray = Children.toArray(children);
  var title = useMemo(function () {
    return childrenArray.find(getValidChild(ModalTitle));
  }, [childrenArray]);
  var content = useMemo(function () {
    return childrenArray.find(getValidChild(ModalContent));
  }, [childrenArray]);
  var footer = useMemo(function () {
    return childrenArray.find(getValidChild(ModalFooter));
  }, [childrenArray]);
  var buttons = useMemo(function () {
    return childrenArray.find(getValidChild(ModalButtons));
  }, [childrenArray]);
  return /*#__PURE__*/_jsxs(StyledModalContainer, {
    children: [title && /*#__PURE__*/_jsx(ModalTitle, _objectSpread(_objectSpread({}, title.props), {}, {
      children: title.props.children
    })), content && /*#__PURE__*/_jsx(ModalContent, _objectSpread(_objectSpread({}, content.props), {}, {
      children: content.props.children
    })), footer && /*#__PURE__*/_jsx(ModalFooter, _objectSpread(_objectSpread({}, footer.props), {}, {
      children: footer.props.children
    })), buttons && /*#__PURE__*/_jsx(ModalButtons, _objectSpread({}, buttons.props))]
  });
};
Modal.Title = ModalTitle;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.Button = ModalButtons;
export { Modal };